export default __webpack_public_path__ + "static/best2025-200cfd56e3ffe63c2e035f945744b91b.jpeg";